import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { profileData } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#121212] border-t border-white border-opacity-25">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About Section */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-[#00FFD1] flex items-center justify-center">
                <span className="text-black font-bold text-xl">DS</span>
              </div>
              <span className="text-white font-bold text-lg">Dr. M D Samudri</span>
            </div>
            <p className="text-white text-opacity-70 leading-relaxed">
              {profileData.motto}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-xl mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-white text-opacity-70 hover:text-[#00FFD1] transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/experience" className="text-white text-opacity-70 hover:text-[#00FFD1] transition-colors">
                  Experience
                </Link>
              </li>
              <li>
                <Link to="/research" className="text-white text-opacity-70 hover:text-[#00FFD1] transition-colors">
                  Research
                </Link>
              </li>
              <li>
                <Link to="/awards" className="text-white text-opacity-70 hover:text-[#00FFD1] transition-colors">
                  Awards
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-xl mb-6">Services</h3>
            <ul className="space-y-3">
              <li className="text-white text-opacity-70">Ayurvedic Surgery</li>
              <li className="text-white text-opacity-70">Chronic Disease Treatment</li>
              <li className="text-white text-opacity-70">Surgical Training</li>
              <li className="text-white text-opacity-70">First Aid Training</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-xl mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="text-[#00FFD1] flex-shrink-0" size={20} />
                <a href={`mailto:${profileData.email}`} className="text-white text-opacity-70 hover:text-[#00FFD1] transition-colors break-all">
                  {profileData.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="text-[#00FFD1] flex-shrink-0" size={20} />
                <a href={`tel:${profileData.phone}`} className="text-white text-opacity-70 hover:text-[#00FFD1] transition-colors">
                  {profileData.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="text-[#00FFD1] flex-shrink-0" size={20} />
                <span className="text-white text-opacity-70">
                  Gadag, Karnataka
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white border-opacity-25">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white text-opacity-70">
              © {currentYear} Dr. M D Samudri. All rights reserved.
            </p>
            <p className="text-white text-opacity-70 text-center">
              {profileData.designation}, {profileData.institution.split(',')[0]}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;